import { Tab } from '@headlessui/react';
import { css, cx } from '@linaria/core';
import { FC } from 'react';
import SvgSliders04Sm from 'modules/Playground/Components/Icons/Sliders04Sm';
import SvgCode02Sm from 'modules/Playground/Components/Icons/Code02Sm';
import { useIsPlaygroundCompatibleModel } from './useIsPlaygroundCompatibleModel';
interface TabButtonsProps {
  className?: string;
}
export const TabButtons: FC<TabButtonsProps> = ({
  className
}) => {
  const isModelCompatible = useIsPlaygroundCompatibleModel();
  return <Tab.List as="div" className={cx(TabButtonContainer, className)}>
      {isModelCompatible ? <Tab className={({
      selected
    }) => cx(TabButton, selected && TabButtonSelected)}>
          <SvgSliders04Sm /> <span className={playgroundTabTextLabel}>UI</span>
        </Tab> : null}
      <Tab className={({
      selected
    }) => cx(TabButton, selected && TabButtonSelected)}>
        <SvgCode02Sm /> <span className={playgroundTabTextLabel}>API</span>
      </Tab>
    </Tab.List>;
};
const TabButtonContainer = "odules__Playground__Components__TabButtons__TabButtons_tsx-TabButtonContainer-tukcyem";
const TabButton = "odules__Playground__Components__TabButtons__TabButtons_tsx-TabButton-t1du4fzd";
const TabButtonSelected = "odules__Playground__Components__TabButtons__TabButtons_tsx-TabButtonSelected-tigxelj";
const playgroundTabTextLabel = "odules__Playground__Components__TabButtons__TabButtons_tsx-playgroundTabTextLabel-p16abtrc";

require("./TabButtons.linaria.module.css!=!../../../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./TabButtons.tsx");